/* Optional cart quantity upgrade; existing Bundler/Seal discounts remain authoritative. */
(() => {
  if (customElements.get('tmw-cart-upgrade')) return;
  let updating = false;
  const planId = (item) => String(item.selling_plan_allocation?.selling_plan?.id || '');
  class TmwCartUpgrade extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.hidden = false;
      this.querySelector('[data-upgrade]').addEventListener('click', () => this.upgrade());
    }
    async upgrade() {
      if (updating) return;
      updating = true;
      const button = this.querySelector('[data-upgrade]');
      const error = this.querySelector('[role="alert"]');
      const root = window.Shopify?.routes?.root || '/';
      const drawerOpen = document.querySelector('cart-drawer')?.classList.contains('active');
      const controls = [...document.querySelectorAll('cart-items button, cart-items input[name="updates[]"], cart-drawer button, cart-drawer input[name="updates[]"], #checkout')].filter(el => !el.disabled);
      controls.forEach(el => { el.disabled = true; });
      document.documentElement.classList.add('tmw-cart-upgrade-pending');
      button.textContent = 'Updating your cart…';
      error.hidden = true;
      let submitted = false;
      try {
        // Recheck the exact line immediately before changing it; never add another line.
        const check = await fetch(`${root}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!check.ok) throw new Error('Your cart could not be checked. Please try again.');
        const cart = await check.json();
        const line = cart.items.find(item => item.key === this.dataset.lineKey);
        const total = cart.items.filter(item => String(item.variant_id) === this.dataset.variant).reduce((sum,item) => sum + item.quantity,0);
        if (!line || total !== 1 || line.quantity !== 1 || planId(line) !== this.dataset.plan || line.original_price !== Number(this.dataset.price) || line.final_price !== line.original_price) {
          throw new Error('Your cart has changed. Refresh the cart to see the latest offer.');
        }
        const sections = [
          { key:'cart-drawer', target:'#CartDrawer', source:'#CartDrawer' },
          { key:'cart-icon-bubble', target:'#cart-icon-bubble', source:'.shopify-section' }
        ];
        for (const id of ['main-cart-items','main-cart-footer']) {
          const target = document.getElementById(id);
          if (target) sections.push({ key:target.dataset.id, target:`#${id} .js-contents`, source:'.js-contents' });
        }
        submitted = true;
        const response = await fetch(`${root}cart/change.js`, {
          method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({id:line.key, quantity:3, sections:sections.map(s=>s.key), sections_url:location.pathname})
        });
        const next = await response.json();
        if (!response.ok || next.errors || next.status) {
          submitted = false;
          throw new Error(typeof next.description === 'string' ? next.description : 'The upgrade could not be applied. Please check availability and try again.');
        }
        const upgraded = next.items.find(item => String(item.variant_id) === this.dataset.variant && planId(item) === this.dataset.plan);
        if (!upgraded || upgraded.quantity !== 3) throw new Error('Please refresh your cart to confirm the available quantity.');
        // Validate all fragments before replacing any. A missing section must not leave stale totals.
        const fragments = sections.map(section => {
          const html = next.sections?.[section.key];
          const source = html && new DOMParser().parseFromString(html,'text/html').querySelector(section.source);
          const target = document.querySelector(section.target);
          if (!source || !target) throw new Error('Your cart was updated. Refresh the cart to see the new total.');
          return {target,html:source.innerHTML};
        });
        fragments.forEach(({target,html}) => { target.innerHTML = html; });
        const drawer = document.querySelector('cart-drawer');
        document.getElementById('CartDrawer-Overlay')?.addEventListener('click', () => drawer?.close());
        const message = 'Updated to 3 boxes of Essential Longevity.';
        const status = document.getElementById(drawerOpen ? 'CartDrawer-LiveRegionText' : 'cart-live-region-text');
        if (status) { status.textContent=message; status.setAttribute('aria-hidden','false'); }
        const focusTarget = drawerOpen ? document.querySelector('#CartDrawer .cart-item__name') : document.querySelector('#main-cart-items .cart-item__name');
        if (drawerOpen && typeof trapFocus === 'function') trapFocus(document.querySelector('#CartDrawer .drawer__inner'),focusTarget);
        else focusTarget?.focus();
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate,{source:'cart-items',cartData:next,variantId:line.variant_id});
      } catch (issue) {
        error.textContent = submitted ? 'Please refresh your cart to confirm the update before trying again.' : issue.message;
        error.hidden = false;
        if (submitted) {
          button.textContent = 'Refresh cart';
          button.onclick = () => location.reload();
          this.upgrade = () => {};
        }
      } finally {
        controls.forEach(el => { if (el.isConnected) el.disabled=false; });
        document.documentElement.classList.remove('tmw-cart-upgrade-pending');
        if (button.textContent === 'Updating your cart…') button.textContent='Upgrade to 3 boxes';
        updating = false;
      }
    }
  }
  customElements.define('tmw-cart-upgrade',TmwCartUpgrade);
})();
